import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_AUDIENCE, AUTH0_SCOPE } from '../constants';

/**
 * Returns a stable function that resolves an Auth0 access token for API calls.
 * Prefer this over getIdTokenClaims().__raw.
 */
export const useAuthToken = () => {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    const getAccessToken = useCallback(async () => {
        if (!isAuthenticated) {
            throw new Error('User is not authenticated');
        }

        return getAccessTokenSilently({
            audience: AUTH0_AUDIENCE,
            scope: AUTH0_SCOPE,
        });
    }, [getAccessTokenSilently, isAuthenticated]);

    return { getAccessToken, isAuthenticated };
};
